import React from 'react';
import {Text} from '../../@FreeModel';
import './styles.scss';
import {useSelector} from "react-redux";
import {selectErrors} from "../../../db/selectors";

const ErrorBox = (): React.ReactElement => {
  const errors = useSelector(selectErrors)
  const messages = errors.map((e) => e.extensions?.message ?? e.message)

  return errors.length > 0 ? (
    <div className="fm-error-box fm-container" style={{margin: '0 auto'}}>
      <Text color="red">{messages}</Text>
    </div>
  ) : (
    <>{null}</>
  );
};

export default ErrorBox;
